<template>
  <div id="app">
    <nav-bar/>
    <div style="height:100%">
      <router-view/>
    </div>
    <div class="fluid-container footer mt-4">
      <p class="text-center text-muted small mb-1">
        Copyright &copy; {{ new Date().getFullYear() }} TWA Textbook. All Rights Reserved.
      </p>
      <p class="text-center text-muted small">
        <a href="https://truewayasl.com/terms" target="_blank" style="text-decoration: none">Terms of Use</a> |
        <a class="ml-2" href="https://truewayasl.com/privacy" target="_blank" style="text-decoration: none">Privacy Policy</a>
      </p>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'

export default {
  components: {
    NavBar
  },
  created () {
    const protected_paths = ['/course', '/access_code', '/token', '/email', '/import_access_codes', '/manage_consumer', '/create_platform', '/manage_platform', '/activate_course', '/manage_sproutvideo', '/manage_product']
    if (protected_paths.find(protected_path => this.$router.currentRoute.path.startsWith(protected_path))) {
      // refresh token for any protected path
      this.$auth.refresh()
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
